
const swellDefenitions = {
	vipTiersSetting : [
	
	{
		option:["","Free Standard Shipping","Free USPS Priority Shipping"]
	},
	{
		option:["","Coupon for entering tier: 15%", "Coupon for entering tier: 20%"]
	},
	{
		option:["","Early access to new releases & promotions","Early access to new releases & promotions"]
	},
	
	],
	//baseVIPTier: {name: "TIER 1", id: "base-tier-id", pointsMultiplier: "1.0", swellrequiredAmountSpent: "0"},
	referralForms: {
		newUserForm: {
			inputType: "text",
			submitText: "NEXT",
			placeholder: "Enter your email to get started...",
			formType: "new"
		},
		existingUserForm: {
			inputType: "text",
			submitText: "SEND",
			labelText: "Now, enter your friends' emails below:",
			placeholder: "Enter your friends' emails (separated by commas)",
			formType: "existing"
		}
	},
	referralShareLinks: [	
		{
			class: "swell-share-referral-facebook",
			href: "javascript:void(0)",
			//icon: "fa fa-facebook-f",
			icon: "//simplycutitees.com/cdn/shop/t/30/assets/swell-facebook.svg?v=14900",
			text: "Share"
		},
		
		{
			class: "swell-share-referral-sms",
			href: "javascript:void(0)",
		 	//icon: "far fa-comment-alt",
		 	icon: "//simplycutitees.com/cdn/shop/t/30/assets/swell-sms.svg?v=14900",
			text: "SMS"
		 }, 
		{
			class: "swell-share-referral-messenger",
			href: "javascript:void(0)",
			//icon: "fab fa-facebook-messenger",
			icon: "//simplycutitees.com/cdn/shop/t/30/assets/swell-message.svg?v=14900",
			text: "Message"
		},
		{

			class: "swell-share-referral-twitter",
			href: "javascript:void(0)",
		    //icon: "fa fa-twitter",
		    icon: "//simplycutitees.com/cdn/shop/t/30/assets/swell-tweet.svg?v=14900",
			text: "Tweet"
		},
		

	],
}	